import React, { useState, useEffect, useRef } from 'react';
import { FiHeart, FiMessageCircle, FiShare2, FiVolume2, FiVolumeX } from 'react-icons/fi';
import { postsAPI } from '../utils/api';
import { Link } from 'react-router-dom';

export default function Reels() {
  const [reels, setReels]   = useState([]);
  const [muted, setMuted]   = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    postsAPI.getExplore()
      .then(r => setReels((r.data.posts || []).filter(p => p.media_type === 'video')))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div style={{maxWidth:480,margin:'0 auto',position:'relative'}}>
      {loading ? (
        <div style={{display:'flex',justifyContent:'center',padding:'80px 0'}}><span className="spinner" /></div>
      ) : reels.length === 0 ? (
        <div style={{textAlign:'center',padding:'80px 20px',color:'var(--text-3)'}}>
          <div style={{fontSize:48,marginBottom:12}}>🎬</div>
          <p className="font-bold" style={{fontSize:16}}>No reels yet</p>
          <p style={{fontSize:14}}>Post a video to see it here!</p>
        </div>
      ) : (
        <div style={{display:'flex',flexDirection:'column',gap:0}}>
          {reels.map(r => (
            <ReelCard key={r.id} reel={r} muted={muted} onMuteToggle={() => setMuted(p => !p)} />
          ))}
        </div>
      )}
      <style>{`@media(max-width:768px){div[style*="max-width:480px"]{padding-top:56px}}`}</style>
    </div>
  );
}

function ReelCard({ reel, muted, onMuteToggle }) {
  const [liked, setLiked] = useState(reel.is_liked);
  const [likes, setLikes] = useState(+reel.likes_count || 0);
  const vidRef = useRef();

  const handleLike = async () => {
    setLiked(p => !p);
    setLikes(l => liked ? l - 1 : l + 1);
    try { await postsAPI.likePost(reel.id); } catch {}
  };

  return (
    <div style={{position:'relative',height:'calc(100vh - 120px)',background:'#000',overflow:'hidden'}}>
      <video
        ref={vidRef}
        src={reel.media_url}
        loop autoPlay muted={muted}
        style={{width:'100%',height:'100%',objectFit:'cover'}}
        playsInline
      />
      {/* Overlay */}
      <div style={{position:'absolute',inset:0,background:'linear-gradient(to top,rgba(0,0,0,.5) 0%,transparent 40%)'}}>
        {/* Right actions */}
        <div style={{position:'absolute',right:16,bottom:100,display:'flex',flexDirection:'column',gap:20,alignItems:'center'}}>
          <Link to={`/profile/${reel.user_id}`}>
            {reel.avatar
              ? <img src={reel.avatar} className="avatar" style={{width:40,height:40,border:'2px solid #fff'}} alt="" />
              : <div style={{width:40,height:40,borderRadius:'50%',background:'linear-gradient(135deg,#E91E8C,#7B2FF7)',display:'flex',alignItems:'center',justifyContent:'center',color:'#fff',fontWeight:700}}>
                  {reel.username?.[0]}
                </div>
            }
          </Link>
          <button onClick={handleLike} style={{display:'flex',flexDirection:'column',alignItems:'center',gap:4,color:'#fff',background:'none',border:'none',cursor:'pointer'}}>
            <FiHeart size={26} fill={liked?'#EF4444':'none'} stroke={liked?'#EF4444':'#fff'} />
            <span style={{fontSize:12}}>{likes}</span>
          </button>
          <button style={{display:'flex',flexDirection:'column',alignItems:'center',gap:4,color:'#fff',background:'none',border:'none',cursor:'pointer'}}>
            <FiMessageCircle size={26}/>
            <span style={{fontSize:12}}>{reel.comments_count}</span>
          </button>
          <button style={{display:'flex',flexDirection:'column',alignItems:'center',gap:4,color:'#fff',background:'none',border:'none',cursor:'pointer'}}>
            <FiShare2 size={24}/>
            <span style={{fontSize:12}}>Share</span>
          </button>
          <button onClick={onMuteToggle} style={{color:'#fff',background:'none',border:'none',cursor:'pointer'}}>
            {muted ? <FiVolumeX size={24}/> : <FiVolume2 size={24}/>}
          </button>
        </div>
        {/* Bottom info */}
        <div style={{position:'absolute',bottom:40,left:16,right:80,color:'#fff'}}>
          <p className="font-bold" style={{marginBottom:6}}>@{reel.username}</p>
          {reel.caption && <p style={{fontSize:13,lineHeight:1.5}}>{reel.caption}</p>}
        </div>
      </div>
    </div>
  );
}
